import { ButtonDef } from "../form/ButtonDef";
import { closestIndex } from "../utils/dom";
import { Modal, ModalProps } from "./Modal";
import { Icon } from "./icons"

export interface IconChoiceProps {
	options: ButtonDef[],
	onChoose: (option: ButtonDef, e: any) => void,
}

export function IconChoice(props: IconChoiceProps) {

	const items = [];
	let i = 0;
	for(let o of props.options) {
		//if (!o.icon) continue;

		items.push(
			<div
				key={o.id}
				className={"option flex vert padding-10 interactive " + (o.selected ? "selected" : "")}
				data-index={i}
			>
				{
					o.icon &&
					<Icon type={o.icon} size="large" />
				}
				{o.title && <span>{o.title}</span>}
			</div>
		);
		i++;
	}

	return (
		<div
			className="icon-choice flex wrap"
			onClick={(e) => {
				const index = closestIndex(e.target, ".option");
				if (index < 0) return;

				const option = props.options[index];
				props.onChoose(option, e);
			}}
		>

			{items}

		</div>
	);
}

export function IconChoiceModal(props: ModalProps & IconChoiceProps) {
	return (
		<Modal
			showSave={false}
			{...props}
			className="bg-brand-primary text-inverse"
		>
			<IconChoice
				options={props.options}
				onChoose={(option, e) => {
					props.onChoose(option, e);
				}}
			/>
		</Modal>
	);
}